import { WeGoAuthorizedLink, PermissionType, Permission, RoleLevel, IKeyValueInterface } from './../../shared/config';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { OrganizationModel, OrganizationBlockModel } from '../models/organization.model';
import { OrganizationService } from '../models/organization.service';
import { OrganizationContactPopupComponent } from './organization-contact-popup.component';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';

// export declare class test {

//   constructor(private authService: AuthService){}

//   public IsAuthorizeLink(permissionName: string, permissionType: string) {
//     return this.authService.IsAuthorizeURL(permissionName, permissionType).map((res: any) => {
//       console.log(res);
//       return res.data;
//     });
//   }
// }

@Component({
  selector: 'wego-organization',
  template: require('../views/organization-list.component.html'),
  providers: [OrganizationService],
})
export class OrganizationListComponent implements OnInit {
  urlOrganizationAdd: string;
  DataListModel: DataListModel;
  organizationList: OrganizationModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  deleteorganizationHashId: string;
  removeContactPersonorganizationHashId: string;
  message: string;
  urlDefaultPage: string;
  urlOrganizationUpdate: string;
  urlOrganizationAdmin: string;
  urlVehicleList: string;
  urlSharedVehicleGroupList: string;
  isParentCheck: boolean;
  isMultipleDelete: boolean;
  urlOrganizationDrivers: string;
  urlOrganizationSubscription: string;
  //AddOrganizationEnabled: boolean;
  urlAdminOfOrganizationList: string;
  urlOrganizationDriverList: string;
  roleLevel = RoleLevel;
  isBlockedOrganizationHashId: string;
  activeFlag: boolean;
  inActiveMessage: string;
  model: OrganizationBlockModel;
  errorModel: IKeyValueInterface[];
  
  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;

  addOrganizationLink: WeGoAuthorizedLink;

  @ViewChild('organizationContactPersonModal') public organizationContactPersonModal: any;
  @ViewChild('childModal') public childModal: any;
  @ViewChild('removeContactPersonModal') public removeContactPersonModal: any;
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('isBlockModal') public isBlockModal: any;

  get isAnyChecked(): boolean {
    if (this.organizationList) {
      let isCheck = this.organizationList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.organizationList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }

  get isDeleteAccess(): boolean {
    if (this.organizationList){
      return this.organizationList.some(x => x.isDeletable);
    }
    else{ return false; }
      
  }

  constructor(private organizationService: OrganizationService
    , private authService: AuthService
    , private router: Router, private translate: TranslateService) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblOrganization');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.model = new OrganizationBlockModel();
    if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance){
      this.DataListModel.searchField = ["organizationName", "contactPersonName", "instanceName"];
    }
    else{
      this.DataListModel.searchField = ["organizationName", "contactPersonName"];
    }
    
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlOrganizationAdd = this.authService.GetURL(ApplicationRouteURL.URL_ORGANIZATION_ADD);
    this.urlOrganizationUpdate = this.authService.GetURL(ApplicationRouteURL.URL_ORGANIZATION_UPDATE);
    this.urlOrganizationAdmin = this.authService.GetURL(ApplicationRouteURL.URL_ORGANIZATION_ADMIN_LIST);
    this.urlOrganizationDrivers = this.authService.GetURL(ApplicationRouteURL.URL_ORGANIZATION_DRIVER_LIST);
    this.urlAdminOfOrganizationList = this.authService.GetURL(ApplicationRouteURL.URL_ADMIN_OF_ORGANIZATION_LIST);
    this.urlOrganizationSubscription = this.authService.GetURL(ApplicationRouteURL.URL_ORGANIZATION_TO_SUBSCRIPTION_LIST);
    this.urlOrganizationDriverList = this.authService.GetURL(ApplicationRouteURL.URL_ORGANIZATION_TO_DRIVER_LIST);
    this.GetOrganizationList();
   // this.IsAddOrganizationEnabled();
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.addOrganizationLink = new WeGoAuthorizedLink(this.urlOrganizationAdd, 
      Permission.PR_ORGANIZATION_OVERVIEW, PermissionType.INSERT,'btn btn-highlight navbar-right', 'LblAddNew');
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetOrganizationList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetOrganizationList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetOrganizationList();
  };

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetOrganizationList();
  }
  public OnExport(event: any) {
    this.isLoading = true;
    this.organizationService.ExportOrganizationList(this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "Organization" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public GetOrganizationList() {
    this.isLoading = true;
    this.organizationService.GetOrganizationList(this.DataListModel)
      .subscribe(
      res => {
        this.organizationList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowContactPersonModal(organizationMasterHashId: string) {
    this.organizationContactPersonModal.organizationMasterHashId = organizationMasterHashId;
    this.organizationContactPersonModal.show();
  }

  public SuccessContactPersonModal($event: any) {
    this.GetOrganizationList();
    this.popupMsg = this.translate.instant('LblContactPersonAddedSuccess');//$event.SuccessMessage;
    this.ShowSuccessPopup();
  }

  public DeleteOrganization(deleteOrganizationList: string[]) {
    this.isLoading = true;
    this.organizationService.DeleteOrganization(deleteOrganizationList)
      .subscribe(
      res => {
        this.DataListModel.currentPage = 1;
        this.GetOrganizationList();
        this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
        this.ShowSuccessPopup();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  public OnParentCheck(isChecked: boolean) {
    this.organizationList.filter(x => x.isDeletable).forEach(x => x.isChecked = isChecked);
  }
  public ShowChildModal(organizationMasterHashId?: string): void {
    this.deleteorganizationHashId = organizationMasterHashId;

    if (organizationMasterHashId) {
      this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
      this.isMultipleDelete = false;
      this.deleteorganizationHashId = organizationMasterHashId;
    }
    else {
      this.popupMsg = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
      this.isMultipleDelete = true;

    }
    this.childModal.show();
  }

  public HideChildModal(): void {
    this.deleteorganizationHashId = "";
    this.childModal.hide();
  }

  public SuccessModalClick(): void {
    let deleteOrganizationList: any[];
    if (this.isMultipleDelete)
      deleteOrganizationList = this.organizationList.filter(x => x.isChecked).map(x => x.organizationMasterHashId);
    else
      deleteOrganizationList.push(this.deleteorganizationHashId);

    this.DeleteOrganization(deleteOrganizationList);
    this.childModal.hide();
  }


  public ShowRemoveContactPersonModal(organizationMasterHashId?: string): void {
    this.removeContactPersonorganizationHashId = organizationMasterHashId;
    this.popupMsg = this.translate.instant('LblRemoveContactPersonConfirm');
    this.removeContactPersonModal.show();
  }

  public HideRemoveContactPersonModal(): void {
    this.removeContactPersonorganizationHashId = "";
    this.removeContactPersonModal.hide();
  }

  public SuccessModalRemoveContactPersonClick(): void {
    this.RemoveOrganizationContactPerson();
    this.removeContactPersonModal.hide();
  }

  private RemoveOrganizationContactPerson(): void {
    this.isLoading = true;
    this.organizationService.RemocveOrganizationContactPerson(this.removeContactPersonorganizationHashId)
      .subscribe(
      res => {
        this.popupMsg = this.translate.instant('LblContactPersonRemoveSuccess');
        this.GetOrganizationList();
        this.isLoading = false;
        this.ShowSuccessPopup();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      },
      () => {
        this.removeContactPersonModal.hide();
        this.isLoading = false;
      });
  }

  // public IsAddOrganizationEnabled() {
  //   this.organizationService.IsAddOrganizationEnabled()
  //     .subscribe(
  //     res => {
  //       if (res.data) {
  //         this.AddOrganizationEnabled = res.data;
  //       }
  //       else {
  //         this.AddOrganizationEnabled = false;
  //       }
  //     },
  //     error => {
  //       this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
  //     });
  // }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  onSubmit(forms: any) {
    this.model.activeFlag = this.activeFlag;
    this.model.organizationMasterHashId = this.isBlockedOrganizationHashId;
    this.BlockUnblockOrganization(JSON.stringify(this.model));
  }

  public BlockUnblockOrganization(formData: any) {
    this.isLoading = true;
    this.organizationService.BlockUnblockOrganization(formData)
      .subscribe(
      res => {
        if (res.data) {
          this.isBlockModal.hide();
          this.DataListModel.currentPage = 1;
          this.GetOrganizationList();
          this.popupMsg = this.translate.instant('LblRecordBlokUnBlockSuccess', [this.module, this.inActiveMessage]);
          this.ShowSuccessPopup();
        }
        else {
          this.isLoading = false;
          this.errorModel = res.error;
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
      );
  }

  public ShowInActiveModal(organizationMasterHashId: string, isActive: boolean): void {
    this.isBlockedOrganizationHashId = organizationMasterHashId;
    this.activeFlag = !isActive;
    this.inActiveMessage = !isActive ? this.translate.instant('LblBlock') : this.translate.instant('LblUnblock');

    this.model.reason = null;
    this.errorModel = null;
    this.popupMsg = this.translate.instant('LblBlockUnblockConfirm', [this.inActiveMessage, this.module]);
    this.isBlockModal.show(this.message);
  }

  public HideInActiveModal(): void {
    this.isBlockedOrganizationHashId = "";
    this.isBlockModal.hide();
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organization/components/organization-list.component.ts